import { useQuery } from 'react-query';
import { useCurrentOrganizationId } from './currentOrganization';
import { queryGet } from './fetch';
import { Offer } from './offers';
import { Product } from './plan';

export enum Recurrence {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  PAST_DUE = 'past_due',
  UNPAID = 'unpaid',
  CANCELED = 'canceled',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  TRIALING = 'trialing',
  PAUSED = 'paused',
}

export interface Subscription {
  id: string;
  organizationId: string;
  products?: Product[];
  offer?: Offer;
  offerId: string;
  status: SubscriptionStatus;
  cancelAt: string;
  expirationDate: string;
  updatedAt: Date;
  createdAt: Date;
}

export const useCurrentSubscriptions = () => {
  const organizationId = useCurrentOrganizationId();
  return useOrganizationSubscription(organizationId);
};

export const useOrganizationSubscription = (organizationId?: string) => {
  return useQuery<Subscription[]>(
    ['organizations', organizationId, 'subscriptions'],
    queryGet(`/v2/organizations/${organizationId}/subscriptions`),
    {
      enabled: !!organizationId,
    },
  );
};
